import * as types from '../actions/types';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../utils/localStorage';

const currentAppVersion = LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion);

if (!currentAppVersion) {
    LocalStorage.setItem(LOCAL_STORAGE_KEYS.appVersion, '1');
}

const initialState = {
    appVersion: LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion),
    deviceStatus: {
        isOnline: true,
        scanner: true,
        printer: true,
    },
};

const global = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.APP_VERSION_CHANGED: {
            return { ...state, appVersion: payload };
        }
        case types.DEVICE_STATUS_CHANGED: {
            return {
                ...state,
                deviceStatus: {
                    ...state.deviceStatus,
                    ...payload,
                },
            };
        }
        default:
            return state;
    }
};

export default global;
